import { render, staticRenderFns } from "./inviteRecord.vue?vue&type=template&id=e5d754fe&scoped=true"
import script from "./inviteRecord.vue?vue&type=script&lang=js"
export * from "./inviteRecord.vue?vue&type=script&lang=js"
import style0 from "./inviteRecord.vue?vue&type=style&index=0&id=e5d754fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d754fe",
  null
  
)

export default component.exports